module.exports = __webpack_public_path__ + "static/business-forms-8ed0664c605eeb40b66876259d0804f5.jpg";